// extracted by mini-css-extract-plugin
module.exports = {"container":"RangeDisplay_container__OETC3","dateWrapper":"RangeDisplay_dateWrapper__fD7I7"};